import React from 'react';
import { Separator } from '@/components/ui/separator';
import ProfileSection from './ProfileSection';
import ProfileMembership from './ProfileMembership';
import ProfileSettings from './ProfileSettings';
import ProfileSecuritySettings from './ProfileSecuritySettings';

const ProfileContent: React.FC = () => {
  return <div className="max-w-4xl mx-auto px-4 space-y-8">
      <ProfileMembership />
      
      <ProfileSecuritySettings />
      
      <ProfileSettings />
    </div>;
};

export default ProfileContent;